// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcbee214","472":"a0cb1021","919":"2c4b0619"}[chunkId] + ".chunk.js";
};